import React from 'react';
import { ReactComponent as VShapeIcon } from '../../../svg/icons/vShape.svg';
import Typography from '@material-ui/core/Typography/Typography';
import makeStyles from '@material-ui/core/styles/makeStyles';

const useStyles = makeStyles((theme: any) => ({
  container: {
    position: 'relative',
    display: 'grid',
    gridTemplateColumns: `0fr repeat(0, [col] 1fr) 0fr`,
    gridTemplateRows: `repeat(5, [row] 0fr)`,
    gridRowGap: theme.spacing(2),
    backgroundColor: 'white',
    padding: theme.spacing(2),
    borderRadius: theme.spacing(2),
    boxShadow:
      '0px 8px 28px -6px rgba(31, 75, 75, 0.12), 0px 18px 88px -4px rgba(31, 75, 75, 0.14)',
  },
  header: {
    textAlignLast: 'center',
    fontWeight: 600,
  },
  answerColumn: {
    borderRadius: '8px 10px 8px 10px',
    gridColumn: 1,
    minWidth: 200,
  },
  icon: {
    width: theme.spacing(2),
    marginRight: theme.spacing(1),
    blockSize: 'auto',
  },
}));

interface IQuestionsAndAnswerForMobile {
  netCapital: string;
  netCapitalMin: number;
  netCapitalMax: number;
  time: string;
}

export default function QuestionsAndAnswerForMobile({
  netCapital,
  netCapitalMin,
  netCapitalMax,
  time,
}: IQuestionsAndAnswerForMobile) {
  const classes = useStyles();

  const qAndA = [
    {
      question: 'Results',
      answer: '',
      img: false,
      header: true,
    },
    {
      question: 'How much capital will I need?',
      answer: `${netCapital}`,
      img: true,
      header: false,
    },
    {
      question: 'How much will it cost me?',
      answer: `$${(netCapitalMin * 0.06) | 0} - $${(netCapitalMax * 0.1) | 0}`,
      img: true,
      header: false,
    },
    {
      question: 'How much of the risk will I bear?',
      answer: `7-20%`,
      img: true,
      header: false,
    },
    {
      question: 'How long will it take?',
      answer: `${time} months`,
      img: true,
      header: false,
    },
  ];

  return (
    <div className={classes.container}>
      {qAndA.map((data, id) => (
        <Typography
          key={id}
          variant={'subtitle2'}
          className={
            classes.answerColumn + ' ' + (data.header && classes.header)
          }
        >
          <div>{data.question}</div>

          {data.img && <VShapeIcon className={classes.icon} />}

          {data.answer}
        </Typography>
      ))}
    </div>
  );
}
